import React, { memo, useContext } from 'react'

import { LanguageContext } from 'context/LanguageContext'
import { countryCode } from 'utils/appUtils'
import { util } from 'utils'
import { useSelector } from 'react-redux'
import { getCDNURL } from 'network/api/networkSettings'

const MobileAppFooter = memo(props => {
    const { strings, formatString } = useContext(LanguageContext)
    const year = util.getFullYear()
    const isLoading = useSelector(state => state.languageChange.get('isLoading'))
    const logo = getCDNURL() + 'assets/images/7eleven_logo_white.webp'

    return (
        <div className="row">
            <div className="col-12 terms-and-social">
                <div className="conditions-and-privacy" tabIndex="0">
                    <img src={logo} alt="7-Eleven logo" className="conditions-and-privacy-logo" />
                    <div className="conditions-and-privacy-content">
                        <nav className="conditions-and-privacy-content-links">
                            <ul>
                                <li className="link-item">
                                    <a
                                        href={
                                            props.userCountry === countryCode.CA
                                                ? strings.LINKS_canadaTermsAndConditions
                                                : strings.LINKS_TermsAndConditions
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {isLoading ? 'Terms & Conditions' : strings.termsLink}
                                    </a>
                                </li>
                                <li className="link-item">
                                    <a
                                        href={
                                            props.userCountry === countryCode.CA
                                                ? strings.LINKS_canadaPrivacyPolicy
                                                : strings.LINKS_PrivacyPolicy
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {isLoading ? ' Privacy Policy' : strings.privacyLink}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <span className="intended-use">
                            {props.userCountry === countryCode.CA
                                ? strings.canadaIntended
                                : isLoading
                                  ? 'This site is intended for residents of the U.S.'
                                  : strings.intended}
                        </span>
                        <span className="rights">
                            &copy;
                            {isLoading
                                ? `${year} 7-Eleven Hawaii, Inc. All rights reserved. Products and services available at participating locations.`
                                : formatString('rights', { year })}
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 disclaimer" tabIndex="0">
                <p className="disclaimer-description">
                    {isLoading
                        ? ' Pricing, promotions and availability may vary by location and at 7NOW Hawaii'
                        : strings.landingPageDisclaimer1}
                </p>
            </div>
        </div>
    )
})

export default MobileAppFooter
